<widget-pannel
		[storageName]="storageName"
		[iconClass]="'fa fa-users fa-fw'"
		[title]="title"
		[alt]="alt"
		[href]="href"
		>
	<div class="mat-elevation-z8">
		<table mat-table [dataSource]="dataSource" style="width: 100%">
			<ng-container matColumnDef="agence">
				<th mat-header-cell *matHeaderCellDef> Agence </th>
				<td mat-cell *matCellDef="let row"
					 [style.display]="row.agence ? '' : 'none'"
					 [attr.rowspan]="row.agence ? row.agence.rows : null"
					 >
					 {{ row.agence ? row.agence.entity.nom : '' }}
				</td>
			</ng-container>

			<ng-container matColumnDef="antenne">
				<th mat-header-cell *matHeaderCellDef> Antenne </th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.antenne ? '' : 'none'"
					[attr.rowspan]="row.antenne ? row.antenne.rows : null"
					>
					{{ row.antenne ? row.antenne.entity.nom : '' }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="parc">
				<th mat-header-cell *matHeaderCellDef> Parc </th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.parc ? '' : 'none'"
					[attr.rowspan]="row.parc ? row.parc.rows : null"
					>
					{{ row.parc ? row.parc.entity.code : '' }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="nom">
				<th mat-header-cell *matHeaderCellDef> Nom </th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.parc ? '' : 'none'"
					[attr.rowspan]="row.parc ? row.parc.rows : null"
					>
					{{ row.parc ? row.parc.entity.nom : '' }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="sousParcs">
				<th mat-header-cell *matHeaderCellDef> Sous-Parcs </th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.sousParc ? '' : 'none'"
					[attr.rowspan]="row.sousParc ? row.sousParc.rows : null"
					>
					{{ row.sousParc ? row.sousParc.entity.code : '' }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="ouvrages">
				<th mat-header-cell *matHeaderCellDef> Ouvrages </th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.sousParc ? '' : 'none'"
					[attr.rowspan]="row.sousParc ? row.sousParc.rows : null"
					>
					{{ row.codesOuvrages }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="responsable">
				<th mat-header-cell *matHeaderCellDef>{{ responsabilite$ | async }}</th>
				<td mat-cell *matCellDef="let row"
					[style.display]="row.responsable ? '' : 'none'"
					[attr.rowspan]="row.responsable ? row.responsable.rows : null"
					>
					<ng-container *ngIf="row.responsable && row.responsable.entity">
						<div>{{ row.responsable.entity.lastName }} {{ row.responsable.entity.firstName }}</div>
						<div>{{ row.responsable.entity.phoneNumber }}</div>
						<div>{{ row.responsable.entity.email }}</div>
					</ng-container>
				</td>
			</ng-container>
		
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	</div>		
</widget-pannel>